import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		title: {
			color: 'var(--mainColor)',
			fontSize: '32px',
			fontWeight: 700,
		},
		backIconWrapper: {
			background: 'var(--white)',
			borderRadius: '4px',
			padding: '5px',
			color: 'var(--mainColor)',
			cursor: 'pointer',
		},
		buttonWrap: {
			margin: '20px',
		},
		tableHead: {
			'& .MuiTableRow-head': {
				'& .MuiTableCell-head': {
					textDecorationLine: 'underline',
					color: '#1976D2',
					fontWeight: 600,
					fontSize: '18px',
					lineHeight: '26px',
					borderBottom: 'none',
				},
			},
		},
		tableRowWrap: {
			'& .MuiTableCell-root': {
				borderBottom: 'none',
				fontSize: '16px',
				lineHeight: '26px',
				padding: '5px',
			},
		},
		tableTotal: {
			'& .MuiTableCell-root': {
				borderBottom: 'none',
				color: '#1976D2',
				fontWeight: 600,
				fontSize: '18px',
				lineHeight: '26px',
				padding: '30px 0',
			},
		},
	}),
);
